import React from 'react';
import Formsy from 'formsy-react';
import { maskRichText } from '../../masks';
import FormsyInput from '../form/FormsyInput';
import SVGClose from '../../svg/Close';

class MenuSelectionModal extends React.Component {
  state = {
    hasIncremented: false
  };

  render() {
    const { menu_selection, isOpen = false } = this.props;
    if (!isOpen) return '';
    return (
      <div className="menu-selection-modal">
        <div className="menu-selection-modal__wrap">
          <span className="menu-selection-modal__close" onClick={this.onClose}>
            <SVGClose />
          </span>

          <h1 className="menu-selection-modal__h1">
            {menu_selection.dish.name}
          </h1>
          {menu_selection.dish.dietary_preference_tags.length > 0 && (
            <div className="menu-selection-modal__p">
              {menu_selection.dish.dietary_preference_tags
                .map(tag => tag.abbreviation)
                .join(' | ')}
            </div>
          )}
          <div className="menu-selection-modal__content">
            <div className="menu-selection-modal__ingredients">
              {menu_selection.dish.public_ingredients && (
                <div>
                  <p className="menu-selection-modal__h2">Ingredients</p>
                  <div className="menu-selection-modal__p">
                    {maskRichText(menu_selection.dish.public_ingredients)}
                  </div>
                </div>
              )}
            </div>

            <div className="menu-selection-modal__notes">
              <p className="menu-selection-modal__h2">
                Please share with us any dish specific requests
              </p>
              <p className="menu-selection-modal__p">
                We can currently alter dishes by exclusions but not additions or
                substitutions. Please let us know any ingredients we should
                omit.
              </p>
              <Formsy>
                <FormsyInput
                  type="text"
                  name="notes"
                  value={menu_selection.notes}
                  onChange={this.handleChange}
                  placeholder=""
                />
              </Formsy>
            </div>
          </div>

          <div className="menu-selection-modal__control-wrap">
            <div className="menu-selection-modal__control">
              <div className="menu-selection-control" onClick={this.decrement}>
                -
              </div>
              <p className="menu-selection-control-count">
                {menu_selection.quantity}
              </p>
              <div className="menu-selection-control" onClick={this.increment}>
                +
              </div>
            </div>
            <div className="menu-selection-modal__next">
              <div
                className="btn btn--hollow-blue btn--full-mobile"
                onClick={this.handleSave}
              >
                Save
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // notes
  handleChange = e => {
    const { quantity = 0 } = this.props.menu_selection;
    const menu_selection = {
      ...this.props.menu_selection,
      [e.target.name]: e.target.value
    };

    if (!quantity) {
      if (!this.state.hasIncremented && e.target.value.length) {
        // if text added increment ingredient
        menu_selection.quantity = quantity + 1;
        this.increment();
      }
    }

    if (!e.target.value.length) {
      // if text erased, decrement
      this.decrement();
    }

    this.props.updateMenuSelection(this.props.index, menu_selection);
  };

  increment = e => {
    const { quantity = 0 } = this.props.menu_selection;
    const menu_selection = {
      ...this.props.menu_selection,
      quantity: quantity + 1
    };
    this.setState({ hasIncremented: true });
    this.props.updateMenuSelection(this.props.index, menu_selection);
  };

  decrement = e => {
    const { quantity = 0 } = this.props.menu_selection;
    if (quantity === 0) {
      this.setState({ hasIncremented: false });
      return;
    }

    const menu_selection = {
      ...this.props.menu_selection,
      quantity: quantity - 1
    };

    // Remove any notes if setting quantity to 0
    if (quantity === 1) {
      menu_selection.notes = '';
      this.setState({ hasIncremented: false });
    }
    this.props.updateMenuSelection(this.props.index, menu_selection);
  };

  onClose = () => {
    this.props.closeModal();
    // delete note and reset quantity to zero
    const menu_selection = {
      ...this.props.menu_selection,
      quantity: 0,
      notes: ''
    };
    this.setState({ hasIncremented: false });
    this.props.updateMenuSelection(this.props.index, menu_selection);
  };

  handleSave = () => {
    this.setState({ hasIncremented: false });
    this.props.closeModal();
  };
}

export default MenuSelectionModal;



// WEBPACK FOOTER //
// ./src/components/shared/MenuSelectionModal.js